"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class AdminHeaderSection extends _react.default.Component {
  render() {
    const _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle;
    return _react.default.createElement("section", {
      className: "header__section  bg-primary  color-primary-contrast"
    }, _react.default.createElement("h2", {
      className: "header__title"
    }, title), _react.default.createElement("h3", {
      className: "header__subtitle"
    }, subtitle));
  }

}

var _default = AdminHeaderSection;
exports.default = _default;
module.exports = exports.default;